// src/utils/numericInput.ts

export type NumLike = number | "";

/**
 * Handles numeric input changes safely.
 * Prevents "" from becoming 0 while typing.
 */
export const handleNumericChange =
  (set: (v: NumLike) => void) =>
  (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;

    if (raw === "") {
      set("");
      return;
    }

    // Allow valid numbers only
    const parsed = Number(raw);
    if (!isNaN(parsed)) {
      set(parsed);
    }
  };

/**
 * Clears 0 on focus for clean typing
 */
export const handleNumericFocus =
  (value: NumLike, set: (v: NumLike) => void) =>
  (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select();

    if (value === 0) {
      set("");
    }
  };

/**
 * Optional: enforce fallback value on blur
 */
export const handleNumericBlur =
  (value: NumLike, set: (v: NumLike) => void, fallback = 0) =>
  () => {
    if (value === "") {
      set(fallback);
    }
  };
